export const FONTS = {
  LOTA: `'Lota', Arial, sans-serif`,
}
